import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { XappCapHandlerService } from '@optima-stride-ai/optima-app-framework';

const PRE_AUTH_XAPP_CAP_KEY = 'optima.xappCap.preAuth';

export const xappCapEmbedRedirectGuard: CanActivateFn = (route) => {
  let encodedXappCap = route.queryParamMap.get('xappCap');
  if (!encodedXappCap) {
    try {
      encodedXappCap = sessionStorage.getItem(PRE_AUTH_XAPP_CAP_KEY);
    } catch {
      // Session storage may be unavailable; continue with the URL-only flow.
    }
  }

  if (!encodedXappCap) {
    return true;
  }

  const response = inject(XappCapHandlerService).decodeXappCapResponse(encodedXappCap);
  if (!response || !('isEmbed' in response && response.isEmbed === true) || !response.isOpen || !response.id) {
    return true;
  }

  return inject(Router).createUrlTree(['/embed'], {
    queryParams: { xappCap: encodedXappCap },
  });
};
